import { render, staticRenderFns } from "./TaskCommit.vue?vue&type=template&id=7e63dbad&scoped=true&"
import script from "./TaskCommit.vue?vue&type=script&lang=js&"
export * from "./TaskCommit.vue?vue&type=script&lang=js&"
import style0 from "./TaskCommit.vue?vue&type=style&index=0&id=7e63dbad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e63dbad",
  null
  
)

export default component.exports